var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col" },
      [
        _c("suc-select-component", {
          attrs: {
            form: _vm.form,
            name: _vm.hourStartName,
            options: _vm.hoursInterval,
            reduce: function (option) {
              return option.value
            },
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col" },
      [
        _c("suc-select-component", {
          attrs: {
            form: _vm.form,
            name: _vm.hourEndName,
            options: _vm.hoursInterval,
            reduce: function (option) {
              return option.value
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }